import { cn } from "@/lib/utils";

import { Button, ButtonProps } from "./button";

interface ButtonWithShortcutProps extends ButtonProps {
  shortcut?: string | string[];
  shortcutPosition?: "right" | "below";
}

export const ButtonWithShortcut = ({
  children,
  shortcut,
  shortcutPosition = "right",
  className,
  ...props
}: ButtonWithShortcutProps) => {
  if (!shortcut) {
    return <Button className={className} {...props}>{children}</Button>;
  }

  const shortcuts = Array.isArray(shortcut) ? shortcut : [shortcut];

  if (shortcutPosition === "below") {
    return (
      <div className="flex flex-col items-center gap-1">
        <Button className={className} {...props}>
          {children}
        </Button>
        <div className="flex items-center gap-0.5 opacity-60">
          {shortcuts.map((key, index) => (
            <span key={index} className="flex items-center gap-0.5">
              <kbd className="px-1.5 py-0.5 text-[10px] font-semibold text-muted-foreground bg-muted/50 border border-border/50 rounded">
                {key}
              </kbd>
              {index < shortcuts.length - 1 && (
                <span className="text-muted-foreground text-[10px]">+</span>
              )}
            </span>
          ))}
        </div>
      </div>
    );
  }

  return (
    <Button className={cn("relative group", className)} {...props}>
      <span className="flex items-center gap-2 w-full">
        {children}
        <span className="ml-auto flex items-center gap-0.5 opacity-0 group-hover:opacity-60 transition-opacity">
          {shortcuts.map((key, index) => (
            <span key={index} className="flex items-center gap-0.5">
              <kbd className="px-1.5 py-0.5 text-[10px] font-semibold bg-muted/50 border border-border/50 rounded">
                {key}
              </kbd>
              {index < shortcuts.length - 1 && (
                <span className="text-[10px]">+</span>
              )}
            </span>
          ))}
        </span>
      </span>
    </Button>
  );
};
